<template>
<div id="app">
    <router-view :key="$route.fullPath" />
</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapMutations, mapGetters } from 'vuex'
import mixins from '@/mixins/mixins'
import listMixins from '@/mixins/listMixins'

export default {
	name: 'App',
	metaInfo: {
        titleTemplate: '%s - Recetalia',
        title: 'Gestión de farmacias',
        htmlAttrs: {
            lang: 'es',
            amp: true
        }
	},
	mixins:[mixins, listMixins],
	computed: {
		...mapGetters(['isAuthenticated','loggedPharmacy'])
	},
	beforeMount() {
        this.loadMe();
    },
	updated() {
		this.loadMe();
	},
	mounted(){
        // console.log(this.$installer)
    },
	methods:{
		...mapMutations(['updateLogged']),
		loadMe(){
			
			if( this.isAuthenticated){
				this.$apollo.query({
					query: gql`query{
						pharmacyLogged {
							id
							name
							businessName
							email
							status
						}
					}`,
					fetchPolicy: 'no-cache'
				})
				.then(({data}) => {
					
					if(data.pharmacyLogged){
						this.updateLogged(data.pharmacyLogged);
					}else{
						// this.$router.push('/logout');
					}
				})
				.catch((err) => {
					console.log(err)
					
				})
			}else{
				
				if(this.$route.name!='Login' && this.$route.name!='register' && this.$route.name!='logout' && this.$route.name!='forgot-password'){
					console.log('logout2')
					// this.$router.push('/logout');
				}
			}
		},
		
		
	}
}
</script>

<style>

</style>
